import React, { Component } from "react";
import { Container } from "reactstrap";

import Jumbo from "../Helper/Jumbo";
import Documents from "../Helper/Documents";

class SmallCap extends Component {
  constructor(props) {
    super(props);
    this.title = "Small Cap Growth Mutual Fund";
    this.ticker = "I: CSMCX | R: CSMVX";
    this.objective = "Long-term Capital Growth";
    this.descriptions = [
      [
        "Overview ",
        "The Fund seeks companies that demonstrate changes in growth at consistently higher levels of profitability than other companies in their respective industries. The strategy emphasizes companies with the requisite resources in managerial, financial, product and/ or technical strength to drive outperformance through a full market cycle.",
      ],
      [
        "Our Difference",
        "Investing in companies positioned for growth coupled with risk management techniques may provide the foundation to build a high conviction portfolio with consistent return generation and lower realized volatility.",
      ],
    ];

    this.pdfs = [
      ["/Small Cap/small-cap-growth-fact-card"],
      ["/Small Cap/small-cap-growth-fund-holdings"],
      ["/Small Cap/congress-small-cap-growth-fund(7.31.2026)"],
      ["/Small Cap/congress-small-cap-growth-fund(1.31.2026)"],
      ["/Small Cap/congress_smallcap_summary_prospectus"],
      ["/All/congress_statutory_prospectus"],
      ["/All/congress_sai"],
      ["/All/Congress Funds SemiAnnual Financial Statements and Additional Information 4.30.2026"],
      ["/Small Cap/Congress Small Cap Growth Institutional Class TSR SemiAnnual 4.30.2026"],
      ["/Small Cap/Congress Small Cap Growth Retail Class TSR SemiAnnual 4.30.2026"],
      ["/Small Cap/Congress Small Cap Growth Fund Institutional Class 10.31.25 TSR"],
      ["/Small Cap/Congress Small Cap Growth Fund Retail Class 10.31.25 TSR"],
      ["/All/Annual Financial Statements and Additional Information 2025"],
      ["/All/2026 Capital Gains Flyer"],
    ];
    this.docNames = [
      "FACT SHEET",
      "HOLDINGS",
      "COMPLETE SMALL CAP GROWTH HOLDINGS - 7/31/2026",
      "COMPLETE SMALL CAP GROWTH HOLDINGS - 1/31/2026",
      "SUMMARY PROSPECTUS",
      "PROSPECTUS",
      "STATEMENT OF ADDITIONAL INFORMATION",
      "SEMI-ANNUAL FINANCIAL STATEMENTS AND ADDITIONAL INFORMATION",
      "SEMI-ANNUAL SHAREHOLDER REPORT - INST CLASS",
      "SEMI-ANNUAL SHAREHOLDER REPORT - RETAIL CLASS",
      "ANNUAL SHAREHOLDER REPORT - INST CLASS",
      "ANNUAL SHAREHOLDER REPORT - RETAIL CLASS",
      "ANNUAL FINANCIAL STATEMENTS AND ADDITIONAL INFORMATION",
      "2026 CAPITAL GAINS ESTIMATES",
    ];
  }

  render() {
    return (
      <Container fluid>
        <Jumbo
          title={this.title}
          ticker={this.ticker}
          objective={this.objective}
          descriptions={this.descriptions}
        />
        <Documents pdfs={this.pdfs} docs={this.docNames} />
											<p style={{paddingLeft:"9%",
                        paddingRight: "9%",
                        paddingTop: "10px",
                        paddingBottom: "2%",
                        fontWeight: "bold"}}>
                          Mutual Fund investing involves risk. Principal Loss is possible.
                          The Fund may invest in foreign securities which involve greater
                          volatility and political, economic and currency risks and differences
                          in accounting methods. Investing in small and medium-sized companies involves
                          greater risks than those associated with investing in large company stocks,
                          such as business risk, significant stock price fluctuations and illiquidity.
                          Growth stocks can perform differently from the market as a whole and from
                          other types of stocks. Growth stocks tend to be sensitive to changes in the
                          earnings of their underlying companies and more volatile than other types of
                          stocks, particularly over the short term.</p>	
      </Container>
    );
  }
}

export default SmallCap;
